/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../graphql.generated'

const defaultOptions = {} as const
export type NoteDraftQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  type: Types.Scalars['String']['input']
}>

export type NoteDraftQuery = {
  __typename?: 'Query'
  noteDraft?: {
    __typename?: 'NoteDraft'
    draftID: string
    revision: number
    value: Types.JSONObject
    createdAt: Date
    updatedAt: Date
    deletesOn?: Date | null
  } | null
}

export type NoteDraftsQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type NoteDraftsQuery = {
  __typename?: 'Query'
  noteDrafts: Array<{ __typename?: 'NoteDraft'; type: string; revision: number; updatedAt: Date }>
}

export type SaveNoteDraftMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  type: Types.Scalars['String']['input']
  value: Types.Scalars['JSONObject']['input']
  expectedRevision?: Types.InputMaybe<Types.Scalars['Int']['input']>
}>

export type SaveNoteDraftMutation = {
  __typename?: 'Mutation'
  saveNoteDraft: {
    __typename?: 'NoteDraft'
    draftID: string
    revision: number
    deletesOn?: Date | null
    createdAt: Date
    updatedAt: Date
  }
}

export type ImportNoteDraftMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  type: Types.Scalars['String']['input']
  value: Types.Scalars['JSONObject']['input']
}>

export type ImportNoteDraftMutation = {
  __typename?: 'Mutation'
  importNoteDraft: {
    __typename?: 'ImportNoteDraftResult'
    imported: boolean
    draft: {
      __typename?: 'NoteDraft'
      draftID: string
      revision: number
      value: Types.JSONObject
      deletesOn?: Date | null
      createdAt: Date
    }
  }
}

export const NoteDraftDocument = gql`
  query noteDraft($uid: ID!, $type: String!) {
    noteDraft(uid: $uid, type: $type) {
      draftID
      revision
      value
      createdAt
      updatedAt
      deletesOn
    }
  }
`

/**
 * __useNoteDraftQuery__
 *
 * To run a query within a React component, call `useNoteDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteDraftQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useNoteDraftQuery(baseOptions: Apollo.QueryHookOptions<NoteDraftQuery, NoteDraftQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NoteDraftQuery, NoteDraftQueryVariables>(NoteDraftDocument, options)
}
export function useNoteDraftLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NoteDraftQuery, NoteDraftQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NoteDraftQuery, NoteDraftQueryVariables>(NoteDraftDocument, options)
}
export type NoteDraftQueryHookResult = ReturnType<typeof useNoteDraftQuery>
export type NoteDraftLazyQueryHookResult = ReturnType<typeof useNoteDraftLazyQuery>
export type NoteDraftQueryResult = Apollo.QueryResult<NoteDraftQuery, NoteDraftQueryVariables>
export const NoteDraftsDocument = gql`
  query noteDrafts($uid: ID!) {
    noteDrafts(uid: $uid) {
      type
      revision
      updatedAt
    }
  }
`

/**
 * __useNoteDraftsQuery__
 *
 * To run a query within a React component, call `useNoteDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteDraftsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useNoteDraftsQuery(baseOptions: Apollo.QueryHookOptions<NoteDraftsQuery, NoteDraftsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NoteDraftsQuery, NoteDraftsQueryVariables>(NoteDraftsDocument, options)
}
export function useNoteDraftsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NoteDraftsQuery, NoteDraftsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NoteDraftsQuery, NoteDraftsQueryVariables>(NoteDraftsDocument, options)
}
export type NoteDraftsQueryHookResult = ReturnType<typeof useNoteDraftsQuery>
export type NoteDraftsLazyQueryHookResult = ReturnType<typeof useNoteDraftsLazyQuery>
export type NoteDraftsQueryResult = Apollo.QueryResult<NoteDraftsQuery, NoteDraftsQueryVariables>
export const SaveNoteDraftDocument = gql`
  mutation saveNoteDraft($uid: ID!, $type: String!, $value: JSONObject!, $expectedRevision: Int) {
    saveNoteDraft(uid: $uid, type: $type, value: $value, expectedRevision: $expectedRevision) {
      draftID
      revision
      deletesOn
      createdAt
      updatedAt
    }
  }
`
export type SaveNoteDraftMutationFn = Apollo.MutationFunction<SaveNoteDraftMutation, SaveNoteDraftMutationVariables>

/**
 * __useSaveNoteDraftMutation__
 *
 * To run a mutation, you first call `useSaveNoteDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNoteDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNoteDraftMutation, { data, loading, error }] = useSaveNoteDraftMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      type: // value for 'type'
 *      value: // value for 'value'
 *      expectedRevision: // value for 'expectedRevision'
 *   },
 * });
 */
export function useSaveNoteDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<SaveNoteDraftMutation, SaveNoteDraftMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SaveNoteDraftMutation, SaveNoteDraftMutationVariables>(SaveNoteDraftDocument, options)
}
export type SaveNoteDraftMutationHookResult = ReturnType<typeof useSaveNoteDraftMutation>
export type SaveNoteDraftMutationResult = Apollo.MutationResult<SaveNoteDraftMutation>
export type SaveNoteDraftMutationOptions = Apollo.BaseMutationOptions<
  SaveNoteDraftMutation,
  SaveNoteDraftMutationVariables
>
export const ImportNoteDraftDocument = gql`
  mutation importNoteDraft($uid: ID!, $type: String!, $value: JSONObject!) {
    importNoteDraft(uid: $uid, type: $type, value: $value) {
      imported
      draft {
        draftID
        revision
        value
        deletesOn
        createdAt
      }
    }
  }
`
export type ImportNoteDraftMutationFn = Apollo.MutationFunction<
  ImportNoteDraftMutation,
  ImportNoteDraftMutationVariables
>

/**
 * __useImportNoteDraftMutation__
 *
 * To run a mutation, you first call `useImportNoteDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportNoteDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importNoteDraftMutation, { data, loading, error }] = useImportNoteDraftMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      type: // value for 'type'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useImportNoteDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<ImportNoteDraftMutation, ImportNoteDraftMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ImportNoteDraftMutation, ImportNoteDraftMutationVariables>(ImportNoteDraftDocument, options)
}
export type ImportNoteDraftMutationHookResult = ReturnType<typeof useImportNoteDraftMutation>
export type ImportNoteDraftMutationResult = Apollo.MutationResult<ImportNoteDraftMutation>
export type ImportNoteDraftMutationOptions = Apollo.BaseMutationOptions<
  ImportNoteDraftMutation,
  ImportNoteDraftMutationVariables
>
